import {
  ActionType,
  CheckboxGroupField,
  DatePickerField,
} from '../../components/AutoForm/AutoFieldNew';
import {useRTQ} from '../../hooks/useRTQ';
import {propositionTypeOptions} from './utils';

export const advisersField: CheckboxGroupField = {
  type: ActionType.checkboxGroup,
  options: [],
  id: 'adviserEmails',
  label: 'Please select the adviser(s)',
};

export const ownersField: CheckboxGroupField = {
  type: ActionType.checkboxGroup,
  options: [],
  id: 'ownerEmails',
  label: 'Please select the owner(s)',
};

export const propositionTypeField: CheckboxGroupField = {
  type: ActionType.checkboxGroup,
  options: propositionTypeOptions,
  id: 'propositionTypes',
  label: 'Please select the Proposition Type(s)',
};

export const nextReviewDateToField: DatePickerField = {
  id: 'nextReviewDateTo',
  label: 'Next annual review date (To):',
  type: ActionType.datepicker,
};

export const nextReviewDateFromField: DatePickerField = {
  id: 'nextReviewDateFrom',
  label: 'Next annual review date (From):',
  type: ActionType.datepicker,
};

export const useLastAtrDateToField = (): DatePickerField => {
  const {atrName} = useRTQ();
  return {
    id: 'lastAtrDateTo',
    label: `Last ${atrName} Date (To):`,
    type: ActionType.datepicker,
  };
};

export const useLastAtrDateFromField = (): DatePickerField => {
  const {atrName} = useRTQ();
  return {
    id: 'lastAtrDateFrom',
    label: `Last ${atrName} Date (From):`,
    type: ActionType.datepicker,
  };
};

export const cqUpdatedDateToField: DatePickerField = {
  id: 'cqUpdatedDateTo',
  label: 'CQ Updated Date (To):',
  type: ActionType.datepicker,
};

export const cqUpdatedDateFromField: DatePickerField = {
  id: 'cqUpdatedDateFrom',
  label: 'CQ Updated Date (From):',
  type: ActionType.datepicker,
};
